var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "deposit detail" }, [
    _c(
      "div",
      { staticClass: "scroll" },
      [
        _c("contents-header", {
          attrs: {
            "bg-type": true,
            tabs: true,
            summary: true,
            title: "EKYC-02-01",
            description: "EKYC-06-03"
          },
          scopedSlots: _vm._u([
            {
              key: "tab",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "tabs bg-type", attrs: { id: "tabs" } },
                    _vm._l(_vm.tabs, function(tab, index) {
                      return _c(
                        "button",
                        {
                          key: index,
                          staticClass: "tab-button tab-button--type1",
                          class: { active: _vm.currentTab === index },
                          on: {
                            click: function($event) {
                              return _vm.tabClick(index)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t(tab)))]
                      )
                    }),
                    0
                  )
                ]
              },
              proxy: true
            },
            {
              key: "summary",
              fn: function() {
                return [
                  _c("div", { staticClass: "summary mtop-20" }, [
                    _vm.lang != _vm.$config.LANG_ENG
                      ? _c("div", { staticClass: "item item-row" }, [
                          _c("div", { staticClass: "tit" }, [
                            _c("span", { staticClass: "exchange-unit" }, [
                              _vm._v("VND")
                            ]),
                            _vm.lang == _vm.$config.LANG_KOR
                              ? _c("span", { staticClass: "text" }, [
                                  _vm._v("연")
                                ])
                              : _vm._e()
                          ]),
                          _vm.lang == _vm.$config.LANG_KOR
                            ? _c("div", { staticClass: "percent" }, [
                                _vm._v("0.10%")
                              ])
                            : _c("div", { staticClass: "percent" }, [
                                _vm._v("0.10%/năm")
                              ])
                        ])
                      : _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "tit" }, [
                            _c("span", { staticClass: "exchange-unit" }, [
                              _vm._v("VND")
                            ])
                          ]),
                          _c("div", { staticClass: "percent" }, [
                            _vm._v(" 0.10% "),
                            _c("span", [_vm._v("annually")])
                          ])
                        ]),
                    _vm.currentTab == 1
                      ? _c("div", [
                          _vm.lang != _vm.$config.LANG_ENG
                            ? _c("div", { staticClass: "item item-row" }, [
                                _c("div", { staticClass: "tit" }, [
                                  _c("span", { staticClass: "exchange-unit" }, [
                                    _vm._v("USD")
                                  ]),
                                  _vm.lang == _vm.$config.LANG_KOR
                                    ? _c("span", { staticClass: "text" }, [
                                        _vm._v("연")
                                      ])
                                    : _vm._e()
                                ]),
                                _vm.lang == _vm.$config.LANG_KOR
                                  ? _c("div", { staticClass: "percent" }, [
                                      _vm._v("0.00%")
                                    ])
                                  : _c("div", { staticClass: "percent" }, [
                                      _vm._v("0.00%/năm")
                                    ])
                              ])
                            : _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "tit" }, [
                                  _c("span", { staticClass: "exchange-unit" }, [
                                    _vm._v("USD")
                                  ])
                                ]),
                                _c("div", { staticClass: "percent" }, [
                                  _vm._v(" 0.00% "),
                                  _c("span", [_vm._v("annually")])
                                ])
                              ])
                        ])
                      : _vm._e()
                  ])
                ]
              },
              proxy: true
            }
          ])
        }),
        _c("article", { staticClass: "contents mtop-24" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentTab == 0,
                  expression: "currentTab == 0"
                }
              ]
            },
            [
              _vm.lang == _vm.$config.LANG_KOR
                ? [
                    _c("article", { staticClass: "contents" }, [
                      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
                        _c("dt", [_vm._v("상품유형")]),
                        _c("dd", [_vm._v("보통예금")]),
                        _c("dt", [_vm._v("상품개요")]),
                        _c("dd", [
                          _vm._v(
                            "일시적 여유자금 보관목적으로 수시로 입금 및 출금을 할 수 있고 예치기간을 정하지 않은 예금"
                          )
                        ]),
                        _c("dt", [_vm._v("가입대상")]),
                        _c("dd", [
                          _vm._v(
                            "개인(IC칩 신분증을 소지한 18세 이상 베트남 거주자)"
                          )
                        ]),
                        _c("dt", [_vm._v("계약기간")]),
                        _c("dd", [_vm._v("제한없음")]),
                        _c("dt", [_vm._v("가입통화")]),
                        _c("dd", [_vm._v("VND(고객별 1좌)")]),
                        _c("dt", [_vm._v("금리 및 이율")]),
                        _c("dd", [_vm._v("VND 연 0.10%")]),
                        _c("dt", [_vm._v("이체한도")]),
                        _vm._m(0),
                        _c("dt", [_vm._v("수수료")]),
                        _c("dd", [_vm._v("해당무")]),
                        _c("dt", [_vm._v("가입방법")]),
                        _c("dd", [_vm._v("스타뱅킹 가입")]),
                        _c("dt", [_vm._v("가입시 필요서류")]),
                        _vm.sessionInfo.isLogin &&
                        _vm.sessionInfo.userInfo.operGroupCd === "VN1"
                          ? _c("dd", [
                              _vm._v("베트남국적고객: IC칩 기반 신분증 "),
                              _c("br"),
                              _vm._v(
                                "핸드폰 소유자 검증 결과(1414번으로 “TTTB” 메시지 전송) "
                              ),
                              _c("br"),
                              _vm._v("거래목적확인서 "),
                              _c("br"),
                              _vm._v(
                                "(예 : 고용계약서, 서비스 계약서, 상업 송장, 등록금 고지서 등) "
                              )
                            ])
                          : _c("dd", [
                              _vm._v("베트남국적고객: IC칩 기반 신분증")
                            ])
                      ])
                    ])
                  ]
                : _vm.lang == _vm.$config.LANG_ENG
                ? [
                    _c("article", { staticClass: "contents" }, [
                      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
                        _c("dt", [_vm._v("Types")]),
                        _c("dd", [_vm._v("Current Account")]),
                        _c("dt", [_vm._v("About the products")]),
                        _c("dd", [
                          _vm._v(
                            "Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds"
                          )
                        ]),
                        _c("dt", [_vm._v("Eligibilty")]),
                        _c("dd", [
                          _vm._v(
                            "Personal customer(Vietnamese residents aged 18+ with an IC chip based ID card)"
                          )
                        ]),
                        _c("dt", [_vm._v("Contract Terms")]),
                        _c("dd", [_vm._v("No restrictions")]),
                        _c("dt", [_vm._v("Available currency")]),
                        _c("dd", [_vm._v("VND(1 account per customer)")]),
                        _c("dt", [_vm._v("Loan Rate")]),
                        _c("dd", [_vm._v("VND 0.10% annually")]),
                        _c("dt", [_vm._v("Transfer Limit")]),
                        _vm._m(1),
                        _c("dt", [_vm._v("Fees")]),
                        _c("dd", [_vm._v("N/A")]),
                        _c("dt", [_vm._v("How to apply")]),
                        _c("dd", [_vm._v("Mobile banking app")]),
                        _c("dt", [
                          _vm._v("Required documents for application")
                        ]),
                        _vm.sessionInfo.isLogin &&
                        _vm.sessionInfo.userInfo.operGroupCd === "VN1"
                          ? _c("dd", [
                              _vm._v(
                                "Vietnamese customers : IC chip-based ID card "
                              ),
                              _c("br"),
                              _vm._v(
                                "Phone number ownership verification (Send message “TTTB” to 1414) "
                              ),
                              _c("br"),
                              _vm._v(
                                "Transaction purpose supporting documents "
                              ),
                              _c("br"),
                              _vm._v(
                                "(Ex : Employment contract, Service agreement, Commercial invoices, Tuition fee notification, etc.) "
                              )
                            ])
                          : _c("dd", [
                              _vm._v(
                                "Vietnamese customers : IC chip-based ID card"
                              )
                            ])
                      ])
                    ])
                  ]
                : [
                    _c("article", { staticClass: "contents" }, [
                      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
                        _c("dt", [_vm._v("Hình thức sản phẩm")]),
                        _c("dd", [_vm._v("Tiền gửi thông thường")]),
                        _c("dt", [_vm._v("Giới thiệu sản phẩm")]),
                        _c("dd", [
                          _vm._v(
                            "Là loại tiền gửi không kì hạn, cho phép khách hàng có thể tự do nộp và rút tiền với mục đích quản lý tạm thời số tiền đang có"
                          )
                        ]),
                        _c("dt", [_vm._v("Đối tượng gia nhập")]),
                        _c("dd", [
                          _vm._v(
                            "Khách hàng cá nhân(Là công dân Việt Nam đủ 18 tuổi trở lên và có CCCD gắn chíp)"
                          )
                        ]),
                        _c("dt", [_vm._v("Thời gian hợp đồng")]),
                        _c("dd", [_vm._v("Không giới hạn")]),
                        _c("dt", [_vm._v("Loại tiền tệ gia nhập")]),
                        _c("dd", [
                          _vm._v(
                            "VND(1 khách hàng chỉ được mở 1 tài khoản trực tuyến)"
                          )
                        ]),
                        _c("dt", [_vm._v("Lãi suất")]),
                        _c("dd", [_vm._v("0.10% hàng năm")]),
                        _c("dt", [_vm._v("Hạn mức giao dịch")]),
                        _vm._m(2),
                        _c("dt", [_vm._v("Biểu phí")]),
                        _c("dd", [_vm._v("Không có nội dung tương ứng")]),
                        _c("dt", [_vm._v("Cách thức gia nhập")]),
                        _c("dd", [_vm._v("Đăng kí Mobile banking")]),
                        _c("dt", [_vm._v("Giấy tờ cần thiết khi gia nhập")]),
                        _vm.sessionInfo.isLogin &&
                        _vm.sessionInfo.userInfo.operGroupCd === "VN1"
                          ? _c("dd", [
                              _vm._v(
                                "Khách hàng là công dân Việt Nam có CCCD gắn chíp "
                              ),
                              _c("br"),
                              _vm._v(
                                "Xác minh số điện thoại chính chủ (Soạn “TTTB” gửi 1414) "
                              ),
                              _c("br"),
                              _vm._v("Tài liệu chứng minh mục đích giao dịch "),
                              _c("br"),
                              _vm._v(
                                "(Ví dụ: Hợp đồng lao động, Thỏa thuận dịch vụ, Hóa đơn bán hàng, Thông báo học phí, v.v…) "
                              )
                            ])
                          : _c("dd", [
                              _vm._v(
                                "Khách hàng là công dân Việt Nam có CCCD gắn chíp"
                              )
                            ])
                      ])
                    ])
                  ]
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentTab == 1,
                  expression: "currentTab == 1"
                }
              ]
            },
            [
              _vm.lang == _vm.$config.LANG_KOR
                ? [_vm._m(3)]
                : _vm.lang == _vm.$config.LANG_ENG
                ? [_vm._m(4)]
                : [_vm._m(5)]
            ],
            2
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v(" 1일 5억VND 비대면 이체한도 제한 "),
      _c("br"),
      _vm._v("(신분증을 지참하여 영업점 방문 시 한도제한 해제 가능) ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v(
        " A daily transfer limit of 500 million VND for mobile transactions "
      ),
      _c("br"),
      _vm._v("(Limit can be lifted by visiting a branch with your ID card) ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v(
        " Hạn mức cho các giao dịch trực tuyến là 500 triệu VNĐ một ngày "
      ),
      _c("br"),
      _vm._v(
        "(Quý khách có thể mang CCCD gắn chíp đến chi nhánh để đăng kí hủy bỏ hạn mức) "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("상품유형")]),
        _c("dd", [_vm._v("보통예금")]),
        _c("dt", [_vm._v("상품개요")]),
        _c("dd", [
          _vm._v(
            "일시적 여유자금 보관목적으로 수시로 입금 및 출금을 할 수 있고 예치기간을 정하지 않은 예금"
          )
        ]),
        _c("dt", [_vm._v("가입대상")]),
        _c("dd", [_vm._v("개인")]),
        _c("dt", [_vm._v("계약기간")]),
        _c("dd", [_vm._v("제한없음")]),
        _c("dt", [_vm._v("가입통화")]),
        _c("dd", [_vm._v("VND, USD")]),
        _c("dt", [_vm._v("금리 및 이율")]),
        _c("dd", [_vm._v("약정이율 : USD 연 0.00%, VND 연 0.10%")]),
        _c("dt", [_vm._v("수수료")]),
        _c("dd", [_vm._v("해당무")]),
        _c("dt", [_vm._v("가입방법")]),
        _c("dd", [_vm._v("스타뱅킹 가입, 영업점 가입")]),
        _c("dt", [_vm._v("가입시 필요서류")]),
        _c("dd", [
          _vm._v(" 본인확인서류 "),
          _c("br"),
          _vm._v("베트남국적고객 : IC칩 기반 신분증 "),
          _c("br"),
          _vm._v("기타국적고객 : 여권 및 비자 ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("Types")]),
        _c("dd", [_vm._v("Current Account")]),
        _c("dt", [_vm._v("About the products")]),
        _c("dd", [
          _vm._v(
            "Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds"
          )
        ]),
        _c("dt", [_vm._v("Eligibilty")]),
        _c("dd", [_vm._v("Personal customer")]),
        _c("dt", [_vm._v("Contract Terms")]),
        _c("dd", [_vm._v("No restrictions")]),
        _c("dt", [_vm._v("Available currency")]),
        _c("dd", [_vm._v("VND, USD")]),
        _c("dt", [_vm._v("Loan Rate")]),
        _c("dd", [
          _vm._v(
            "Agreed interest rate : USD 0.00% annually , VND 0.10% annually"
          )
        ]),
        _c("dt", [_vm._v("Fees")]),
        _c("dd", [_vm._v("N/A")]),
        _c("dt", [_vm._v("How to apply")]),
        _c("dd", [_vm._v("Mobile banking app, Apply at the branch")]),
        _c("dt", [_vm._v("Required documents for application")]),
        _c("dd", [
          _vm._v(" Identity verification documents "),
          _c("br"),
          _vm._v("Vietnamese customers : IC chip-based ID card "),
          _c("br"),
          _vm._v("Other nationalities : Passport and visa ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("Hình thức sản phẩm")]),
        _c("dd", [_vm._v("Tiền gửi thông thường")]),
        _c("dt", [_vm._v("Giới thiệu sản phẩm")]),
        _c("dd", [
          _vm._v(
            "Là hình thức tiền gửi mà quý khách có thể tự do nạp và rút tiền mà không cần phải ấn định thời gian"
          )
        ]),
        _c("dt", [_vm._v("Đối tượng gia nhập")]),
        _c("dd", [_vm._v("Cá nhân")]),
        _c("dt", [_vm._v("Thời gian hợp đồng")]),
        _c("dd", [_vm._v("Không giới hạn")]),
        _c("dt", [_vm._v("Loại tiền tệ gia nhập")]),
        _c("dd", [_vm._v("VND, USD")]),
        _c("dt", [_vm._v("Lãi suất")]),
        _c("dd", [_vm._v("Lãi suất cam kết : USD 0.00%/năm , VND 0.10% /năm")]),
        _c("dt", [_vm._v("Biểu phí")]),
        _c("dd", [_vm._v("Không có nội dung tương ứng")]),
        _c("dt", [_vm._v("Cách thức gia nhập")]),
        _c("dd", [_vm._v("Đăng kí Mobile banking, Tham gia chi nhánh")]),
        _c("dt", [_vm._v("Giấy tờ cần thiết khi gia nhập")]),
        _c("dd", [
          _vm._v(" Giấy tờ cần thiết để mở tài khoản tiền gửi "),
          _c("br"),
          _vm._v("Khách hàng Việt Nam : Thẻ CCCD gắn chíp "),
          _c("br"),
          _vm._v("Khách hàng nước ngoài : Hộ chiếu hoặc Visa ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }